// extracted by mini-css-extract-plugin
module.exports = {"componentsSmsCode":"styles_componentsSmsCode__3FYtr","sendBtn":"styles_sendBtn__3uSsA"};